import React, { useEffect, useMemo, useRef, useState } from "react";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import { useSelector, useDispatch } from "react-redux";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";
import {
	fetchDesignation,
} from "../../redux/actions/designationAction";
import {
	fetchInstituteData,
} from "../../redux/actions/getInstitutesAction";
import {
	fetchCompanyData,
} from "../../redux/actions/getCompaniesAction";
import { useNavigate } from "react-router-dom";
import { fetchGenders, selectGender } from "../../redux/actions/genderActions";
import { fetchCityData, selectCity, clearCityList } from "../../redux/actions/citiesAction";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { Button, Col, Form, Modal, Overlay, Popover, Row } from "react-bootstrap";
// import Select from "react-select";
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import Flatpickr from "react-flatpickr";
import moment from "moment";
import { fetchOrgRegdInsData } from "../../redux/actions/getRegdInsAction";
import { fetchOrgRegdCompData } from "../../redux/actions/getRegdComAction";

function EditCandid() {

	const sessionId = localStorage.getItem("sessionId");
	const userUID = localStorage.getItem("userUID");
	const userEmail = localStorage.getItem("email");
	const [email, setEmail] = useState(localStorage.getItem("email") || "");
	// const [firstName, setFirstName] = useState(localStorage.getItem("entityName") || "");
	// const [lastName, setLastName] = useState(localStorage.getItem("entityName") || "");
	const entityName = localStorage.getItem("entityName") || "";
	const [firstName, setFirstName] = useState(entityName.split(" ")[0] || "");
	const [lastName, setLastName] = useState(entityName.split(" ")[1] || "");
	const userFirstName = localStorage.getItem("entityName");
	const dispatch = useDispatch();
	console.log("userUID", userUID);
	const [dob, setDob] = useState('')
	const targetRef = useRef(null);
	const [showTooltip, setShowTooltip] = useState(false);
	const [OrganizationName, setOrganizationName] = useState("");
	const [InsName, setInsName] = useState("");
	const [display, setDisplay] = useState(false);
	const [cityNameOption, setCityNameOption] = useState([])
	//---------Current Active AS state---------\\
	const [orgType, setOrgType] = useState("");

	//-----------For institution and company ID--------//	
	const [orgTypeId, setOrgTypeId] = useState("");


	const toggleTooltip = () => {
		console.log("Toggling Tooltip");
		setShowTooltip((prev) => !prev);
	};
	const [orgCity, setOrgCity] = useState(null);
	const handleCitySelect1 = (selectedOption) => {
		if (selectedOption) {
			setOrgCity(selectedOption.value);
		} else {
			setOrgCity(null);

		}
	};
	const [fileName, setFileName] = useState("");
	const handleFileChange = (event) => {
		const file = event.target.files[0]; // Get the selected file
		if (file) {
			setFileName(file.name); // Set the filename in state
		}
	};
	const [getOrgInsTId, setGenOrgInstId] = useState("");
	const [newOrgType, setnewOrgType] = useState(null);

	const handleSaveInstitution = async () => {
		// setDisplay(true);

		const formData = new FormData();
		formData.append("orgName", OrganizationName);
		formData.append("OrgType", "UnRegdInstitution");
		formData.append("CityID", orgCity);
		formData.append("OrgLogo", fileName);
		formData.append("sessionId", sessionId);
		console.log("formData", formData);

		try {
			const res = await axios.post("/Feature/AddGnrlOrgData", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			console.log("res", res);
			dispatch(fetchOrgRegdInsData());
			//setInstituteId(res.data.responseData.id)
			setInsName("")
			// setGenOrgInstId(res.data.responseData.id);
			// setnewOrgType(res.data.responseData.value);
			toast.success(`${res.data.message} The newly created institution is now available at the top of the dropdown. Please select it.`);
			// setShowTooltip(false);
			setOrganizationName("");
			setOrgCity(null);
			setFileName("");
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
			} else {
				toast.error(error.response?.data?.message || "An error occurred");
			}
		}
	};

	const [searchTerm, setSearchTerm] = useState("")

	const getCityList = async (pageNumber = 1, pageSize = 10) => {
		try {
			const response = await axios.post(`/MasterData/GetCitiesDDL?Search=${searchTerm}&CountryName=India`, {
				pageNumber,
				pageSize
			})
			console.log("Get City Name List==>", response)
			const cityList = response.data.responseData.citiesDDL.map((val) => ({
				value: val.id,
				label: val.name,
			}));
			setCityNameOption(cityList)
		}
		catch (error) {
			//toast.error(error.message || 'Something went wrong while fetching city data',)
		}
	}

	useEffect(() => {
		getCityList();
	}, [searchTerm]);

	const handleCitySelectOrg = (selectedOption) => {
		setOrgCity(selectedOption ? selectedOption.value : "")
		console.log("Selected City:", selectedOption);
		setSearchTerm(""); // Search term clear karein
		setCityNameOption([]); // Dropdown options clear karein
	};

	// ...............................PROFILE Start.......................................
	const [displays, setDisplays] = useState(false);
	const [headLine, setHeadLine] = useState("");
	const [website, setWebsite] = useState("");
	const [about, setAbout] = useState("");
	const [curretactive, setCurretactive] = useState("");
	// const [orgType, setOrgType] = useState("");
	const [profileImage, setProfileImage] = useState();
	const [profileImageview, setProfileImageview] = useState("");
	const [error, setError] = useState(null);
	const [contactNo, setContactNo] = useState("")
	const [address, setAddress] = useState("")

	// Handle Profile Image Change
	const handleProfileImageChange = (event) => {
		const selectedFile = event.target.files[0];
		const validImageTypes = ['image/jpeg', 'image/png', 'image/jpg'];

		if (selectedFile) {
			// Validate file type
			if (!validImageTypes.includes(selectedFile.type)) {
				setError('Only JPEG and PNG images are allowed.');
				setProfileImage(null);
				setProfileImageview(null);
				return;
			}

			//  size (limit to 10MB)
			const maxSizeInMB = 10;
			if (selectedFile.size > maxSizeInMB * 1024 * 1024) {
				setError(`File size should not exceed ${maxSizeInMB}MB.`);
				setProfileImage(null);
				setProfileImageview(null);
				return;
			}

			// If valid, update the state
			setProfileImage(selectedFile);
			setProfileImageview(URL.createObjectURL(selectedFile));
			setError(null);
		}
	};


	// ...............................PROFILE End.......................................
	const navigate = useNavigate();
	// ...............................Gender DDL.......................................

	const [genderValue, setGenderValue] = useState("");
	const { genderOptions } = useSelector(
		(state) => state.gender
	);

	useEffect(() => {
		dispatch(fetchGenders());
	}, [dispatch]);
	const handleGenderSelect = (selectedOption) => {
		if (selectedOption) {
			setGenderValue(selectedOption.value);
		} else {
			setGenderValue(null);

		}
	};
	// ...............................Gender DDL.......................................

	// ...............................Institute DDL.......................................
	//   const [regdType, setRegdType] = useState("");
	//   const [orgType, setOrgType] = useState("");
	// //   const [instituteId, setInstituteId] = useState(null);
	//   const { getallorgsList, selectedinstituteId }  
	//   = useSelector(
	// 	(state) => state.getRegdIns 
	//   );
	//   useEffect(() => {
	// 	// dispatch(fetchAllOrgsData());
	// 	dispatch(fetchOrgRegdInsData());
	//   }, [dispatch]);
	//   console.log("getallorgsList", getallorgsList);
	// const [regdType, setRegdType] = useState("");
	// const [orgType, setOrgType] = useState("");
	const [instituteId, setInstituteId] = useState(null);
	const { getallorgsList, selectedinstituteId }
		= useSelector(
			(state) => state.getRegdIns
		);

	const reversedOrgList = useMemo(() => {
		return [...getallorgsList].reverse(); // Create a new reversed copy
	}, [getallorgsList]);

	useEffect(() => {
		// dispatch(fetchAllOrgsData());
		dispatch(fetchOrgRegdInsData());
	}, [dispatch]);
	console.log("getallorgsList", getallorgsList);

	const [formChanged, setFormChanged] = useState(false);

	const handleFieldChange = (setter, value) => {
		setter(value);
		setFormChanged(true); // Enable Submit button
	};

	// ...............................City DDL.......................................

	const { cityList } = useSelector((state) => state.cities);
	const [cityId, setcityId] = useState("");
	useEffect(() => {
		dispatch(fetchCityData());
		// return () => {
		// 	dispatch(clearCityList()); // Clear cityList when component unmounts
		// };
	}, [dispatch]);
	const handleCityInputChange = (inputValue) => {
		console.log("check input==>", inputValue)
		dispatch(fetchCityData(inputValue));
	};

	const handleCitySelect = (selectedOption) => {
		if (selectedOption) {
			setcityId(selectedOption.value);
		} else {
			setcityId(null);
		}
	};

	const handleImageChange = async (e) => {
		const file = e.target.files[0];
		if (file) {
			setProfileImage(file); // Store for upload
			const previewUrl = URL.createObjectURL(file); // or use base64 if preferred
			setProfileImageview(previewUrl); // For image preview
			const toBase64 = (file) =>
				new Promise((resolve, reject) => {
					const reader = new FileReader();
					reader.readAsDataURL(file);
					reader.onload = () => resolve(reader.result);
					reader.onerror = (error) => reject(error);
				});

			// in handler:
			const base64 = await toBase64(file);
			localStorage.setItem("ProfileImage", base64);
			// localStorage.setItem("ProfileImage", previewUrl); 
		}
	};

	// ...............................City DDL.......................................

	// ...............................Get PROFILE Start.......................................
	const [profileData, setProfileData] = useState("");
	const GetProfile = async () => {
		try {
			const res = await axios.get(`/Candidate/GetBasicProfile?UID=${userUID}`);
			console.log("===>", res);
			setProfileData(res.data.responseData);
			const userData = res.data.responseData;
			localStorage.setItem("entityName", `${userData.firstName} ${userData.lastName}`);
			// localStorage.setItem("firstName", userData.firstName);
			// localStorage.setItem("lastName", userData.lastName);
			localStorage.setItem("langName", userData.langName);
			localStorage.setItem("cityName", userData.cityName);
			localStorage.setItem("genderName", userData.genderName);
			localStorage.setItem("ProfileImage", userData.profileImage);
		} catch (error) {
			console.log("error", error);
		}
	};
	useEffect(() => {
		GetProfile();
	}, []);
	console.log("profileData", profileData);



	// ...............................Get PROFILE End.......................................
	const [isSaveClicked, setIsSaveClicked] = useState(false);

	const BasicProfile = async (e) => {
		setIsSaveClicked(true);
		// e.preventDefault();
		try {
			setDisplays(true);
			//const trimmedContactNo = contactNo?.trim();
			if (
				genderValue &&
				cityId &&
				profileImage !== ""

			) {
				const formData = new FormData();

				formData.append("CityId", cityId);
				formData.append("Email", email);
				formData.append("FirstName", firstName);
				formData.append("phoneNumber", contactNo);
				formData.append("LastName", lastName);
				formData.append("GenderId", genderValue);
				formData.append("ProfileImage", profileImage);
				formData.append("Dob", moment(dob).format("YYYY-MM-DD"));
				formData.append("LangId", 2);
				formData.append("SessionId", sessionId);
				const res = await axios.post(
					"/Account/UpdateCandidateProfile",
					formData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
						},
					}
				);
				toast.success(res.data.message);
				GetProfile();
				setDisplays(false);
				//setFormChanged(false)

			} else {
				toast.error("please enter required fields!");
			}
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.warning(error.response.data.message);
			} else {
				toast.error(error.response?.data?.message || "An error occurred");
			}
		}
	};
	const handleSave = () => {
		setIsSaveClicked(true); // Mark that save was clicked
		if (!profileImage) {
			setError("Please select a profile image.");
		} else {
			setError("");
			console.log("Profile image saved:", profileImage);
		}
	};
	console.log("instituteId", instituteId);

	// const AddProfile = async () => {

	// 	e.preventDefault();

	// 	let orgType = 0;
	// 	if ((orgType === "1" || orgType === 1) && !instituteId) {
	// 		toast.error("Institute is required.");
	// 		setDisplays(false);
	// 		return;
	// 	}
	// 	if ((orgType !== "1" && orgType !== 1) && !companyId) {
	// 		toast.error("Company is required.");
	// 		setDisplays(false);
	// 		return;
	// 	}
	// 	if ((orgType !== "1" && orgType !== 1) && !designationId) {
	// 		toast.error("Designation Name is required.");
	// 		setDisplays(false);
	// 		return;
	// 	}

	// 	setDisplays(true);

	// 	if (instituteId) {
	// 		orgType = regdType === 4 ? 4 : (regdType === 1 ? 1 : getOrgInsTId);
	// 	}
	// 	else if (companyListId) {
	// 		orgType = regdType === 3 ? 3 : (regdType === 2 ? 2 : getOrgInsTId);
	// 	}

	// 	let body = {
	// 		sessionId: sessionId,
	// 		currentlyActiveAs: curretactive,
	// 		orgType: String(orgType),
	// 	};
	// 	console.log("body", body);

	// 	if (orgType === "1" || orgType === 1) {
	// 		// body.insttnId = regdType === "1" || "4" ? instituteId : null;
	// 		body.insttnId = instituteId;
	// 		body.compId = null;
	// 		body.designationName = null;
	// 		body.headLine = headLine;
	// 		body.about = about;
	// 		body.website = website;
	// 	} else {
	// 		body.insttnId = null;
	// 		body.compId = companyListId;
	// 		// body.compId = regdType === "2" || "3" ? companyListId : null;
	// 		body.designationName = designationId;
	// 		body.headLine = headLine;
	// 		body.about = about;
	// 		body.website = website;
	// 	}
	// 	console.log("body===>11", body);

	// 	try {
	// 		const dandidate = await axios.post("/CandidateData/add", body);
	// 		toast.success(dandidate.data.message);
	// 		navigate(`/Resume/Candidate?userUID=${userUID}`);

	// 	} catch (error) {
	// 		if (error.response && error.response.status === 404) {
	// 			toast.warning(error.response.data.message);
	// 		} else {
	// 			toast.error(error.response?.data?.message || "An error occurred");
	// 		}
	// 	}
	// };

	// const UpdateProfile = async (e) => {
	// 	e.preventDefault();
	// 	try {
	// 		setDisplays(true);
	// 		if (orgType === '1') {
	// 			if (!instituteId && !getOrgInsTId) {
	// 				toast.error("Please select an Institution.");
	// 				return;
	// 			}
	// 		} else if ((!companyId && !getOrgInsTId1) || !designationId) {
	// 			toast.error("Please fill all required fields.");
	// 			return;
	// 		}

	// 		let body = {
	// 			sessionId: sessionId,
	// 			currentlyActiveAs: curretactive,
	// 			orgType: newOrgType === null ? String(orgType) : newOrgType,
	// 		};

	// 		if (orgType === "1") {
	// 			body.insttnId = getOrgInsTId === "" ? instituteId : getOrgInsTId;
	// 			body.compId = null;
	// 			body.dsgntnId = null;
	// 			body.headLine = headLine;
	// 			body.about = about;
	// 			body.website = website;
	// 		} else {
	// 			body.insttnId = null;
	// 			body.compId = getOrgInsTId1 === '' ? companyId : getOrgInsTId1;
	// 			body.dsgntnId = designationId;
	// 			body.headLine = headLine;
	// 			body.about = about;
	// 			body.website = website;
	// 		}
	// 		const res = await axios.post("/CandidateData/Update", body);

	// 		toast.success(res.data.message);
	// 		setCompanyId("");
	// 		setInstituteId("");
	// 		setHeadLine("");
	// 		setWebsite("");
	// 		setAbout("");
	// 		setDisplays(false);
	// 		navigate(`/Resume?userUID=${userUID}`)
	// 	} catch (error) {
	// 		if (error.response && error.response.status === 404) {
	// 			toast.warning(error.response.data.message);
	// 		} else {
	// 			toast.error(error.response?.data?.message || "An error occurred");
	// 		}
	// 	}
	// };

	const AddProfile = async (e) => {
		// e.preventDefault();
		let orgTypeId = "";

		if ((orgType === '1' || orgType === 1) && !instituteId) {
			toast.error("Institute is required.");
			setDisplays(false);
			return;
		}
		if ((orgType !== '1' && orgType !== 1) && !companyListId) {
			toast.error("Company is required.");
			setDisplays(false);
			return;
		}
		if ((orgType !== '1' && orgType !== 1) && !designationId) {
			toast.error("Designation name is required.");
			setDisplays(false);
			return;
		}
		if (website && website.trim() !== "") {
			const urlPattern = /^(https:\/\/|www\.)[\w-]+(\.[\w-]+)+([\/?#].*)?$/;
			if (!urlPattern.test(website)) {
				toast.error("Please enter a valid website link!");
				return;
			}
		}
		setDisplays(true);

		if (instituteId) {
			orgTypeId = regdType === 4 ? 4 : (regdType === 1 ? 1 : getOrgInsTId);
		} else if (companyListId) {
			orgTypeId = regdType === 3 ? 3 : (regdType === 2 ? 2 : getOrgInsTId);
		}

		let body = {
			sessionId: sessionId,
			currentlyActiveAs: curretactive,
			orgType: String(orgTypeId),
		};
		console.log("body", body);

		if (orgType === "1" || orgType === 1) {
			body.insttnId = instituteId;
			body.compId = null;
			body.designationName = null;
			body.headLine = headLine;
			body.about = about;
			body.website = website;
			body.address = address
		} else {
			body.insttnId = null;
			body.compId = companyListId;
			body.designationName = designationId;
			body.headLine = headLine;
			body.about = about;
			body.website = website;
			body.address = address
		}
		console.log("body===>11", body);

		try {
			const dandidate = await axios.post("/CandidateData/add", body);
			toast.success(dandidate.data.message);
			navigate(`/Resume/Candidate?userUID=${userUID}`);
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.warning(error.response.data.message);
			} else {
				toast.error(error.response?.data?.message || "An error occurred");
			}
		}
	};


	const Profile = async (e) => {
		e.preventDefault();
		const profileExists = await checkProfile();
		// if (profileExists) {
		// 	UpdateProfile(e);
		// } else {
		AddProfile();
		// }
	};

	const checkProfile = async () => {
		const data = { sessionId: sessionId };
		try {
			const response = await axios.post("/CandidateData/Check", data);
			const profileExists = response.data.responseData;

			return profileExists;
		} catch (error) {
			console.error("Error fetching profile status:", error);
			return false;
		}
	};

	useEffect(() => {
		checkProfile();
	}, []);

	// .............................. designation Dropdown ...............................


	const [designationSearch, setDesignationSearch] = useState("");
	const [designationId, setDesignationId] = useState("");
	const { designationList } = useSelector(
		(state) => state.designation
	);

	useEffect(() => {
		dispatch(fetchDesignation());
	}, [dispatch]);

	const handleDesignation = (selectedOption) => {
		console.log("selectedOption", selectedOption);

		if (selectedOption) {
			setDesignationId(selectedOption.label);
			// dispatch(selectDesignation(selectedOption.value));
		} else {
			setDesignationId(null);

		}
	};
	console.log("designationId", designationId);

	// ...............................Designation Dropdown.......................................

	// ...............................Institute Dropdown.......................................
	const [instituteSearch, setInstituteSearch] = useState("");
	// const [instituteId, setInstituteId] = useState(null);
	const { getinstituteList } = useSelector(
		(state) => state.institute
	);
	useEffect(() => {
		dispatch(fetchInstituteData());
	}, [dispatch]);

	// const handleInstitute = (selectedOption) => {
	// 	if (selectedOption) {
	// 		setInstituteId(selectedOption.value);
	// 	} else {
	// 		setInstituteId(null);

	// 	}
	// };
	const handleInstitute = (selectedOption) => {
		console.log("selectedOption", selectedOption);

		if (selectedOption) {
			console.log("selectedOption", selectedOption);

			// dispatch(selectGetInstitute(selectedOption.value));
			setInstituteId(selectedOption.value);
			setOrgTypeId(selectedOption.tagId);
			setRegdType(selectedOption.tagId);
		} else {
			setInstituteId(null);
		}
	};
	// ...............................Institute Dropdown.......................................

	// ...............................Company Dropdown.......................................
	const [companySearch, setCompanySearch] = useState("");
	const [companyId, setCompanyId] = useState(null);
	const { getcompaniesList } = useSelector(
		(state) => state.getcompanies
	);

	useEffect(() => {
		dispatch(fetchCompanyData());
	}, [dispatch]);

	const handleCompany = (selectedOption) => {
		if (selectedOption) {
			setCompanyId(selectedOption.value);
		} else {
			setCompanyId(null);

		}
	};

	// const handleActive = (selectedOption) => {
	// 	if (selectedOption) {
	// 		setCurretactive(selectedOption.value);

	// 		if (selectedOption.value === "1") {
	// 			setOrgType("1");
	// 		} else { // If not student
	// 			setOrgType("2");
	// 		}
	// 	} else {
	// 		setCurretactive('');
	// 		setOrgType(''); // Reset orgType if no option is selected
	// 	}
	// };

	const handleActive = (selectedOption) => {
		console.log("selectedOption", selectedOption);

		if (selectedOption) {
			setCurretactive(selectedOption.value);

			if (selectedOption.value === "1") {
				console.log("Selected Option==>if")
				setOrgType("1");
			} else { // If not student
				console.log("Selected Option==>else")
				setOrgType("2");

			}
		} else {
			setCurretactive('');
			setOrgType(''); // Reset orgType if no option is selected
		}
	};

	// const handleOrgType = (selectedOption) => {
	// 	if (selectedOption) {
	// 		setOrgType(selectedOption.value);
	// 	} else {
	// 		setOrgType(null);

	// 	}
	// };


	const activeOptions = [
		{ value: "1", label: "Student" },
		{ value: "2", label: "Professional" },
	];
	const orgOptions = [
		{ value: "1", label: "Institution" },
		{ value: "2", label: "Company" },
	];
	// ...............................company Dropdown.......................................
	const [activeStep, setActiveStep] = useState(1);
	const [step, setStep] = useState(1);

	// const handleNext = () => {
	// 	setActiveStep(activeStep + 1);
	// };

	const handlePrev = () => {
		setActiveStep(activeStep - 1);
	};

	// const isFormValid = firstName.trim() !== "" && lastName.trim() !== "" && email.trim() !== "" && genderValue.trim() !== null && cityId.trim() !== null;

	const handleNext = () => {
		if (
			// !firstName || !contactNo || !lastName || !email || !genderValue || !cityId || !dob
			!(firstName || "").trim() ||
			!(contactNo || "").trim() ||
			!(lastName || "").trim() ||
			!(email || "").trim() ||
			!genderValue ||
			!cityId ||
			!dob
		) {
			setDisplays(true); // Show errors
		} else {
			BasicProfile();
			setDisplays(false); // Hide errors
			setStep(2); // Move to next step
		}
	};


	const [newOrgType1, setnewOrgType1] = useState(null);
	const [getOrgInsTId1, setGenOrgInstId1] = useState(null);

	const handleSaveInstitution1 = async () => {
		// setDisplay(true);

		const formData = new FormData();
		formData.append("orgName", OrganizationName);
		formData.append("OrgType", "UnRegdCompany");
		formData.append("CityID", orgCity);
		formData.append("OrgLogo", fileName);
		formData.append("sessionId", sessionId);
		console.log("formData", formData);

		try {
			const res = await axios.post("/Feature/AddGnrlOrgData", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			console.log("res====>", res);
			dispatch(fetchOrgRegdCompData());
			//setCompanyListId(res.data.responseData.id)
			//setOrgType(res.data.responseData.value)
			setInsName("")
			// setGenOrgInstId1(res.data.responseData.id);
			//  setnewOrgType1(res.data.responseData.value);
			toast.success(`${res.data.message} The newly created Company is now available at the top of the dropdown. Please select it.`);
			setOrganizationName("")
			setOrgCity("")
			setInsName("")
			setFileName("")
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
			} else {
				toast.error(error.response?.data?.message || "An error occurred");
			}
		}
	};


	const [regdType, setRegdType] = useState("");
	console.log("regdType", regdType);

	const [companyListId, setCompanyListId] = useState(null);
	const { getRegdCompList, selectedcompaniesId } = useSelector(
		(state) => state.getRegdComp
	);

	const reversedCompList = useMemo(() => {
		return [...getRegdCompList].reverse(); // Create a new reversed copy
	}, [getRegdCompList]);


	useEffect(() => {
		dispatch(fetchOrgRegdCompData());
	}, [dispatch]);

	const handleSelectCompany = (selectedOption) => {
		console.log("selectedOption", selectedOption);

		if (selectedOption) {
			// dispatch(selectGetCompanies(selectedOption.value));
			setCompanyListId(selectedOption.value);
			setOrgType(selectedOption.tagId);
			setRegdType(selectedOption.tagId);

		} else {
			setCompanyListId(null);
		}
	};
	console.log("profileData", profileData);

	useEffect(() => {
		if (profileData) {
			setGenderValue(profileData?.genderId);
			setContactNo(profileData?.phoneNumber)
			dispatch(selectGender(profileData?.genderId));
			setcityId(profileData?.cityId);
			dispatch(fetchCityData(profileData?.cityName));
			dispatch(selectCity(profileData?.cityId));
			setProfileImageview(profileData?.profileImage);
			setProfileImage(profileData?.profileImage)
			setDob(profileData?.dob);
			setLastName(profileData?.lastName);

		}
	}, [profileData]);

	return (
		// Prifile setting...................START.........................


		<div className="main-container edit-candi pb-5 pt-3 settings">
			<div className="content-wrapper">
				<div className="title delete-title ">
					<h1>
						{" "}
						<span className="orange-box"></span> User information
					</h1>
				</div>


				{step === 1 && (
					<div
						//  className="card delete-card"
						className={`content ${activeStep === 1 ? "active" : ""} card delete-card `}
					>
						<div className="mb-3">
							<h5 className="fw-bold border-custom d-inline textcolor ">Basic info</h5>
						</div>
						<div className="">

							<div className="form-row">
								<div className="post-form-group text-transform-email email-label-category">
									<label htmlFor="category">
										Email
									</label>
									<input
										type="email"
										id="tag"
										placeholder="Email"
										// onChange={(e) => setEmail(e.target.value)}
										onChange={(e) => setEmail(e.target.value)}
										value={email}
										invalid={displays && email === ""}
										className="Normal-Input-Fill"
										disabled
									/>
									{displays && !email ? (
										<span className="error_msg_lbl text-red">Enter email </span>
									) : null}
								</div>
								<div className="post-form-group">
									<label>
										Contact No <span className="text-red">*</span>
									</label>
									<input
										type="text"
										placeholder="Contact No"
										value={contactNo}
										onChange={(e) => setContactNo(e.target.value)}
										id="contact"
										name="contact"
										className="Normal-Input-Fill"
										invalid={displays && contactNo === ""}

									/>
									{displays && !contactNo ? (
										<span className="error_msg_lbl text-red">
											Enter Contact No{" "}
										</span>
									) : null}
								</div>
							</div>

							<div className="form-row">

								<div className="post-form-group">
									<label>
										First name <span className="text-red">*</span>
									</label>
									<input
										type="text"
										placeholder="First Name"
										value={firstName}
										onChange={(e) => setFirstName(e.target.value)}
										id="email"
										name="email"
										className="Normal-Input-Fill"
										invalid={displays && firstName === ""}
									/>
									{displays && !firstName ? (
										<span className="error_msg_lbl text-red">
											Enter first name{" "}
										</span>
									) : null}
								</div>
								<div className="post-form-group">
									<label>
										Last name <span className="text-red">*</span>
									</label>
									<input
										type="text"
										placeholder="Last Name"
										value={lastName}
										onChange={(e) => setLastName(e.target.value)}
										id="email"
										name="email"
										className="Normal-Input-Fill"
										invalid={displays && lastName === ""}
									/>
									{displays && !lastName ? (
										<span className="error_msg_lbl text-red">
											Enter last name{" "}
										</span>
									) : null}
								</div>

							</div>
							<div className="form-row">
								<div className="form-group">
									<label htmlFor="gender" className="mt-0">
										Gender <span className="text-red">*</span>
									</label>
									<ReactSelect
										options={genderOptions}
										onChange={handleGenderSelect}
										value={
											genderOptions.find(
												(option) => option.value === genderValue
											) || null
										}
										placeholder="Select Gender"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control Dark-Input-from-group"
										isClearable
									/>
									{displays && !genderValue ? (
										<span className="error_msg_lbl text-red">Select gender </span>
									) : null}
								</div>
								<div className="form-group">
									<label htmlFor="city" className="mt-0">
										City <span className="text-red">*</span>
									</label>
									<ReactSelect
										options={cityList}
										onChange={handleCitySelect}
										value={
											cityList.find((option) => option.value === cityId) || null
										}
										onInputChange={handleCityInputChange}
										placeholder="Search & Select City"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control Dark-Input-from-group"
										isClearable
									/>

									{displays && !cityId ? (
										<span className="error_msg_lbl text-red">Search & select city </span>
									) : null}
								</div>
								{/* <div className="form-group">
									<label htmlFor="city" className="mt-0">
										DOB <span className="text-red">*</span>
									</label>
									<Flatpickr
										id="dob"
										className="form-control Dark-Input-from-group"
										required
										onChange={(date) => setDob(date[0])}
										value={dob}
										invalid={displays && dob === ""}
										options={{
											maxDate: new Date(), // Disable future dates
											static: true, // Keeps the calendar visible on click         
										}}
									/>
								</div> */}

							</div>


							<div className="form-row">
								<div className="form-group">
									<label htmlFor="city" className="mt-0">
										DOB
										<span className="text-red"> *</span>
									</label>
									<Flatpickr
										id="dob"
										className="form-control Dark-Input-from-group"
										required
										onChange={(date) => setDob(date[0])}
										placeholder="Select DOB"
										value={dob}
										invalid={displays && dob === ""}
										options={{
											maxDate: new Date(), // Disable future dates
											static: true, // Keeps the calendar visible on click         
										}}
									/>
									{displays && !dob ? (
										<span className="error_msg_lbl text-red">Select DOB </span>
									) : null}
								</div>
								<div className="form-group">
									<label htmlFor="ProfileImg">Profile Image</label>
									<input
										type="file"
										id="ProfileImg"
										className="form-control Dark-Input-from-group"
										required
										accept="image/jpeg, image/png, image/jpg"
										//onChange={handleProfileImageChange}
										onChange={handleImageChange}
									//style={{ height: '56px', paddingTop: '15px' }}
									/>

									{/* {error && <span className="error_msg_lbl text-red">{error}</span>}
									{!error && !profileImage && (
										<span className="error_msg_lbl text-red">Select an image</span>
									)} */}
									{isSaveClicked && error && (
										<span className="error_msg_lbl text-red">Select an image</span>
									)}
								</div>

							</div>
							<div className="form-row">
								<div className="form-group">
									{profileImageview && (
										<img
											src={profileImageview}
											alt="Profile Preview"
											width={100}
											height={100}
										/>
									)}
								</div>
								{/* <div className="form-group">
									<label htmlFor="address">Address</label>
									<textarea
									    style={{ height: "auto" }}
									    rows={2}
										id="address"
										className="form-control Dark-Input-from-group"
										placeholder="Address"
										value={address}
										onChange={(e) => setAddress(e.target.value)}
									/>
									{displays && !address ? (
													<span className="error_msg_lbl text-red">
														Enter About
													</span>
												) : null}
								</div> */}
							</div>


							<div className="p-4 col-md-12 text-end mt-4">
								<button
									type="button"
									className="btn btn-primary"
									onClick={() => {
										handleNext();
									}
									}
									disabled={
										// email === "" ||
										// contactNo === "" ||
										// firstName === "" ||
										// lastName === "" ||
										// genderValue === null ||
										// cityId === null ||
										// dob === null
										(email || "").trim() === "" ||
										(contactNo || "").trim() === "" ||
										(firstName || "").trim() === "" ||
										(lastName || "").trim() === "" ||
										genderValue === null ||
										cityId === null ||
										dob === null
									}
								>
									Next
								</button>
							</div>
						</div>
					</div>
				)}

				{step === 2 && (
					<div
						className={`content ${activeStep === 2 ? "active" : ""} card delete-card mt-3 `}
					>
						<div className="mb-3">
							<h5 className="fw-bold border-custom d-inline textcolor">Profile info</h5>
						</div>
						<div className="post-job-details-form Edit-Card-details-form">
							<div className="row">
								<div className="col-md-6 mb-2">
									<div className="post-form-group">
										<label htmlFor="category">Currently active <span className="text-red">*</span></label>
										<ReactSelect
											options={activeOptions}
											onChange={handleActive}
											value={activeOptions.find((option) => option.value === curretactive) || null}
											placeholder="Select currently active"
											styles={customStyles}
											classNamePrefix="react-select"
											className="form-control"
											isClearable
										/>
										{displays && !curretactive ? (
											<span className="error_msg_lbl text-red">
												Select currently active
											</span>
										) : null}
									</div>
								</div>
								{/* <div className="col-md-6">
									<div className="post-form-group">
										<label htmlFor="tag">Organization Type <span className="text-red">*</span>
											</label>
										<ReactSelect
											options={orgOptions}
											onChange={handleOrgType}
											value={orgOptions.find((option) => option.value === orgType) || null}
											placeholder="Select org type"
											styles={customStyles}
											classNamePrefix="react-select"
											className="form-control"
											isClearable
										/>
										{displays && !orgType ? (
											<span className="error_msg_lbl text-red">
												Select organization type
											</span>
										) : null}

									</div>
								</div> */}
								{orgType && (<>
									{orgType === "1" ? (
										<>
											{/* <div className="col-md-6 mb-2">
												<div className="post-form-group">
													<div className="d-flex">
														<label htmlFor="jobApplyType">Institution <span className="text-red">*</span></label>
														<a
															href="#"
															ref={targetRef}
															onClick={(e) => {
																e.preventDefault();
																toggleTooltip();
															}}
															className="createModal ms-2"
														>
															Create New
														</a>
														<Overlay
															target={targetRef.current}
															show={showTooltip}
															placement="right"
															rootClose
															container={document.querySelector(".modal")}
															onHide={() => setShowTooltip(false)} // Close when clicking outside
														>
															<Popover id="popover-basic" className="overlay-popover-modal">
																<Popover.Header as="h3" className="Dark-Body-Card-group">Create Institute</Popover.Header>
																<Popover.Body className="Dark-Body-Card-group">
																	<Form>

																		<div className="create-comp-style">
																			<label className="mb-1 Text-mb-Create">Institute name</label>
																			<input
																				type="text"
																				value={OrganizationName}
																				onChange={(e) => {
																					setOrganizationName(e.target.value);
																					setInsName(e.target.value);
																				}}
																				placeholder="Enter Institute name"
																				className="mb-2 form-control Dark-Input-from-group"
																			/>
																		</div>

																		<div className="create-comp-style">
																			<label className="mb-1 Text-mb-Create">City</label>
																			<ReactSelect
																				options={cityList}
																				onChange={handleCitySelect1}
																				value={
																					cityList.find(
																						(option) => option.value === orgCity
																					) || null
																				}
																				onInputChange={handleCityInputChange}
																				placeholder="Search & Select City"
																				classNamePrefix="react-select"
																				className="form-control Dark-Input-from-group create-comp-city"
																				styles={customStyles}
																				isClearable
																			/>
																		</div>

																		<div className=" mt-2 mb-2 Text-mb-Create">
																			<label className="mb-1">Institute Logo</label>
																			<input
																				type="file"
																				id="lastName"
																				className="form-control Dark-Input-from-group"
																				placeholder=""
																				onChange={handleFileChange}
																			
																			/>
																			
																		</div>
																		<div className="d-flex justify-content-end">
																			<Button
																				variant="primary"
																				size="sm"
																				onClick={handleSaveInstitution}
																				className="me-2"
																			>
																				Save
																			</Button>
																			<Button
																				variant="secondary"
																				size="sm"
																				onClick={() => setShowTooltip(false)}
																			>
																				Cancel
																			</Button>
																		</div>
																	</Form>
																</Popover.Body>
															</Popover>
														</Overlay>
													</div>
													{InsName !== "" ? (
														<div>
															<input
																type="text"
																value={InsName}
																placeholder="Enter Org name"
																className="mb-2 form-control Dark-Input-from-group"
																disabled
															/>
														</div>
													) : (
														<ReactSelect
															options={getinstituteList}
															onChange={handleInstitute}
															value={
																getinstituteList.find(
																	(option) => option.value === instituteId
																) || null
															}
															placeholder="Select Institute Type"
															styles={customStyles}
															classNamePrefix="react-select"
															className="form-control"
															onInputChange={(inputValue) =>
																setInstituteSearch(inputValue)
															}
															isClearable
															invalid={displays && instituteId === "" || InsName === ""}
														/>
													)}
													{displays && !instituteId ? (
														<span className="error_msg_lbl text-red">
															Select Institution
														</span>
													) : null}

												</div>
											</div> */}

											<Col md={6} className="mb-2">
												<Form.Group controlId="institution">
													<Form.Group controlId="Industry">
														<Form.Label className="class-type">
															Institute
															<span className="text-red"> *</span>
														</Form.Label>
														{InsName !== "" ? (
															<div>
																<input
																	type="text"
																	value={InsName}
																	placeholder="Enter Org name"
																	className="mb-2 form-control Dark-Input-from-group"
																	disabled
																/>
															</div>
														) : (
															<div className="post-form-group mb-0">
																<ReactSelect
																	options={reversedOrgList}
																	onChange={(selectedOption) => handleFieldChange(handleInstitute, selectedOption)}

																	value={reversedOrgList.find((option) => option.value === instituteId) || null}
																	placeholder="Select Institute"
																	classNamePrefix="react-select"
																	className="form-control Dark-Input-from-group"
																	formatOptionLabel={(option) => (
																		<div style={{ fontWeight: option.tagId === 1 ? "bold" : "normal" }}>
																			{option.label}
																		</div>
																	)}
																	styles={customStyles}

																	isClearable
																/>


															</div>
														)}
													</Form.Group>
													{display && !instituteId ? (
														<span className="error_msg_lbl">Select institute </span>
													) : null}
													<a
														href="#"
														ref={targetRef}
														onClick={(e) => {
															e.preventDefault();
															toggleTooltip();
														}}
														className="createModal"
													// isDisabled={!selectedIndustryId} // Disable until industry is selected
													>
														Create New
													</a>
													<Overlay
														target={targetRef.current}
														show={showTooltip}
														placement="right"
														rootClose
														container={document.querySelector(".modal")}
														onHide={() => setShowTooltip(false)} // Close when clicking outside
													>
														<Popover id="popover-basic" className="overlay-popover-modal" >
															<Popover.Header as="h3" className="Dark-Body-Card-group">Create institute</Popover.Header>
															<Popover.Body className="Dark-Body-Card-group">
																<Form>

																	<div className="create-comp-style">
																		<label className="mb-1 Text-mb-Create">Institute name</label>
																		<input
																			type="text"
																			value={OrganizationName}
																			onChange={(e) => {
																				setOrganizationName(e.target.value);
																				setInsName(e.target.value);
																			}}
																			placeholder="Enter Institute name"
																			className="mb-2 form-control Dark-Input-from-group"
																		/>
																	</div>

																	<div className="create-comp-style">
																		<label className="mb-1 Text-mb-Create">City</label>
																		<ReactSelect
																			options={cityNameOption}
																			onInputChange={(value) => setSearchTerm(value)} // User input pe search ho
																			onChange={handleCitySelectOrg} // Select hone ke baad clear ho jaye
																			placeholder="Search & Select City"
																			classNamePrefix="react-select"
																			className="form-control Dark-Input-from-group"
																			styles={customStyles}
																			isClearable
																		/>
																	</div>

																	<div className=" mt-2 mb-2 Text-mb-Create">
																		<label className="mb-1">Institute logo</label>
																		<input
																			type="file"
																			id="lastName"
																			className="form-control Dark-Input-from-group"
																			placeholder=""
																			onChange={handleFileChange}
																		/>
																	</div>
																	<div className="d-flex justify-content-end">
																		<Button
																			variant="primary"
																			size="sm"
																			onClick={() => {
																				handleSaveInstitution()
																				setShowTooltip(false)
																			}}
																			className="me-2"
																		>
																			Save
																		</Button>
																		<Button
																			variant="secondary"
																			size="sm"
																			onClick={() => setShowTooltip(false)}
																		>
																			Cancel
																		</Button>
																	</div>
																</Form>
															</Popover.Body>
														</Popover>
													</Overlay>
												</Form.Group>
											</Col>
											<div className="post-form-row mb-2">
												<div className="post-form-group">
													<label htmlFor="address">Address</label>
													<textarea
														style={{ height: "auto" }}
														rows={2}
														id="address"
														className="form-control Dark-Input-from-group"
														placeholder="Address"
														value={address}
														onChange={(e) => setAddress(e.target.value)}
													/>
													{/* {displays && !address ? (
														<span className="error_msg_lbl text-red">
															Enter Address
														</span>
													) : null} */}
												</div>
											</div>
											<div className="col-md-6 mb-2">
												<div className="post-form-group">
													<label htmlFor="minSalary">HeadLine</label>
													<input
														type="text"
														id="minSalary"
														placeholder="HeadLine"
														required
														onChange={(e) => setHeadLine(e.target.value)}
														value={headLine}
														invalid={displays && headLine === ""}
														className="Normal-Input-Fill"
													/>
												</div>
											</div>

											<div className="col-md-6 mb-2">
												<div className="post-form-group text-transform-email">
													<label htmlFor="experience">Website</label>
													<input
														type="text"
														id="experience"
														placeholder="Website"
														onChange={(e) => setWebsite(e.target.value)}
														value={website}
														invalid={displays && website === ""}
														className="Normal-Input-Fill"
													/>
												</div>
											</div>

											<div className="post-form-row mb-2">
												<div className="post-form-group">
													<label htmlFor="maxSalary">About</label>
													<textarea
														type="text"
														id="maxSalary"
														placeholder="About"
														onChange={(e) => setAbout(e.target.value)}
														value={about}
														invalid={displays && about === ""}
														className="normalinput-fill-border"
													/>
												</div>
											</div>

										</>
									) : (
										<>
											<div className="post-form-group">
												<label htmlFor="externalUrl">Company <span className="text-red">*</span></label>
												{InsName !== "" ? (
													<div>
														<input
															type="text"
															value={InsName}
															placeholder="Enter Org name"
															className="mb-2 form-control Normal-Input-Fill"
															disabled
														/>
													</div>
												) : (
													<div className="post-form-group mb-0">
														<ReactSelect
															options={reversedCompList}
															// onChange={handleSelectCompany}
															onChange={(selectedOption) => handleFieldChange(handleSelectCompany, selectedOption)}

															// onChange={(option) => {
															//   handleFieldChange(setCompanyListId, option ? option.value : ""); // Track changes
															//   setOrgType(option ? option.tag : ""); // Set organization type
															// }}
															value={
																reversedCompList.find(
																	(option) => option.value === companyListId
																) || null
															}
															formatOptionLabel={(option) => (
																<div style={{ fontWeight: option.tagId === 2 ? "bold" : "normal" }}>
																	{option.label}
																</div>
															)}
															// styles={{
															//   control: (provided) => ({
															//     ...provided,
															//     boxShadow: "none",  // Removes the blue outline
															//     borderColor: "#ccc", // Sets a neutral border
															//     "&:hover": {
															//       borderColor: "#aaa", // Lighter border on hover
															//     },
															//   }),
															//   option: (provided, state) => ({
															//     ...provided,
															//     fontWeight: state.data.tagId === 2 ? "bold" : "normal",
															//   }),
															// }}
															placeholder="Select Company"
															classNamePrefix="react-select"
															className="form-control Dark-Input-from-group"
															styles={customStyles}
															isClearable
														/>
													</div>
												)}
												{display && !companyListId ? (
													<span className="error_msg_lbl">Select Company </span>
												) : null}
												<a
													href="#"
													ref={targetRef}
													onClick={(e) => {
														e.preventDefault();
														toggleTooltip();
													}}
													className="createModal"
												// isDisabled={!selectedIndustryId} // Disable until industry is selected
												>
													Create New
												</a>
												<Overlay
													target={targetRef.current}
													show={showTooltip}
													placement="right"
													rootClose
													container={document.querySelector(".modal")}
													onHide={() => setShowTooltip(false)} // Close when clicking outside
												>
													<Popover id="popover-basic" className="overlay-popover-modal">
														<Popover.Header as="h3" className="Dark-Body-Card-group">Create Company</Popover.Header>
														<Popover.Body className="Dark-Body-Card-group">
															<Form>
																<div>
																	<label className="mb-1 Text-mb-Create">Company name</label>
																	<input
																		type="text"
																		value={OrganizationName}
																		onChange={(e) => {
																			setOrganizationName(e.target.value);
																			setInsName(e.target.value);
																			// setGetOrgInsTId1(e.target.value)
																			// handleFieldChange(setGetOrgInsTId1,e.target.value,"getOrgInsTId1")
																		}}
																		placeholder="Enter Company name"
																		className="mb-2 form-control Dark-Input-from-group"
																	/>
																</div>
																<div>
																	<label className="mb-1 Text-mb-Create">City</label>
																	{/* <ReactSelect
                          options={cityList}
                          //onChange={handleCitySelect1}
                          onChange={(option) => handleFieldChange(setOrgCity, option ? option.value : "")}
                          value={
                            cityList.find(
                              (option) => option.value === orgCity
                            ) || null
                          }
                          onInputChange={handleCityInputChange}
                          placeholder="Search & Select City"
                          classNamePrefix="react-select"
                          className="form-control Dark-Input-from-group"
                          styles={customStyles}
                          isClearable
                        /> */}
																	<ReactSelect
																		options={cityNameOption}
																		onInputChange={(value) => setSearchTerm(value)} // User input pe search ho
																		onChange={handleCitySelectOrg} // Select hone ke baad clear ho jaye
																		placeholder="Search & Select City"
																		classNamePrefix="react-select"
																		className="form-control Dark-Input-from-group"
																		styles={customStyles}
																		isClearable
																	/>
																</div>
																<div className=" mt-2 mb-2 Text-mb-Create">
																	<label className="mb-1">Company Logo</label>
																	<input
																		type="file"
																		id="lastName"
																		className="form-control Dark-Input-from-group"
																		placeholder=""
																		onChange={handleFileChange}

																	/>

																</div>
																<div className="d-flex justify-content-end">
																	<Button
																		variant="primary"
																		size="sm"
																		onClick={() => {
																			handleSaveInstitution1()
																			setShowTooltip(false)
																		}}
																		className="me-2"
																	>
																		Save
																	</Button>
																	<Button
																		variant="secondary"
																		size="sm"
																		onClick={() => setShowTooltip(false)}
																	>
																		Cancel
																	</Button>
																</div>
															</Form>
														</Popover.Body>
													</Popover>
												</Overlay>
											</div>
											<div className="post-form-row">


												<div className="post-form-group">
													<label htmlFor="externalUrl">Designation <span className="text-red">*</span></label>
													<ReactSelect
														options={designationList}
														onChange={handleDesignation}
														value={
															designationList.find(
																(option) => option.label === designationId
															) || null
														}
														placeholder="Select Designation Type"
														styles={customStyles}
														classNamePrefix="react-select"
														className="form-control"
														onInputChange={(inputValue) =>
															setDesignationSearch(inputValue)
														}
														isClearable
														invalid={displays && designationSearch === ""}
													/>
													{displays && !designationId ? (
														<span className="error_msg_lbl text-red">
															Select Designation
														</span>
													) : null}
												</div>
											</div>
											<div className="post-form-row mb-2">
												<div className="post-form-group">
													<label htmlFor="address">Address</label>
													<textarea
														style={{ height: "auto" }}
														rows={2}
														id="address"
														className="form-control Dark-Input-from-group"
														placeholder="Address"
														value={address}
														onChange={(e) => setAddress(e.target.value)}
													/>
													{/* {displays && !address ? (
														<span className="error_msg_lbl text-red">
															Enter Address
														</span>
													) : null} */}
												</div>
											</div>
											<div className="post-form-row">
												<div className="post-form-group">
													<label htmlFor="minSalary">HeadLine</label>
													<input
														type="text"
														id="minSalary"
														placeholder="HeadLine"
														required
														onChange={(e) => setHeadLine(e.target.value)}
														value={headLine}
														invalid={displays && headLine === ""}
														className="Normal-Input-Fill"
													/>
													{/* {displays && !headLine ? (
													<span className="error_msg_lbl text-red">
														Enter HeadLine
													</span>
												) : null} */}
												</div>
												<div className="post-form-group text-transform-email">
													<label htmlFor="experience">Website</label>
													<input
														type="text"
														id="experience"
														placeholder="Website"
														onChange={(e) => setWebsite(e.target.value)}
														value={website}
														invalid={displays && website === ""}
													/>
													{/* {displays && !website ? (
													<span className="error_msg_lbl text-red">
														Enter Website
													</span>
												) : null} */}
												</div>
											</div>

											<div className="post-form-row">
												<div className="post-form-group">
													<label htmlFor="maxSalary">About</label>
													<textarea
														type="text"
														id="maxSalary"
														placeholder="About"
														onChange={(e) => setAbout(e.target.value)}
														value={about}
														invalid={displays && about === ""}
														className="normalinput-fill-border"
													/>
													{/* {displays && !about ? (
													<span className="error_msg_lbl text-red">
														Enter About
													</span>
												) : null} */}
												</div>
											</div>
										</>
									)}
								</>
								)}

							</div>

							<div className="post-form-row">

							</div>



							<div className="text-end mt-4 d-flex justify-content-between">
								<div className="previousBtnCont d-flex align-items-center">
									{/* <ArrowBackIosNewSharpIcon className="material-symbols-sharp" /> */}
									<button
										type="button"
										className="btn btn-primary"
										onClick={() => setStep(1)}
									>
										Previous
									</button>
								</div>
								<button
									type="button"
									className="btn btn-primary"
									onClick={(e) => Profile(e)}
								>
									Save
								</button>
							</div>
						</div>
					</div>
				)}
			</div>
		</div>


	);
}

export default EditCandid;
